import { IStore } from '../interfaces/common/store.interface';

export class StateManagementHelpers {
  /// Helper function to create new state object
  static mergeState = (state: IStore, newData: IStore) => ({
    ...state,
    ...newData,
  });
}
